import Alpine from 'alpinejs'

// Custom select dropdown
Alpine.data('customSelect', (config) => ({
  name: config.name,
  selected: config.selected || '',
  placeholder: config.placeholder,
  options: config.options,
  isOpen: false,
  selectOption(value) {
    this.selected = value;
    this.isOpen = false;
    this.$nextTick(() => {
      if (this.$refs.filters_form) {
        this.$refs.filters_form.submit();
      }
    });
  }
}))

// Custom select with groups for ArcheType
Alpine.data('customSelectWithGroups', (config) => ({
  name: config.name,
  selected: config.selected || '',
  placeholder: config.placeholder,
  groups: config.groups,
  isOpen: false,
  selectOption(value) {
    this.selected = value;
    this.isOpen = false;
    this.$nextTick(() => {
      if (this.$refs.filters_form) {
        this.$refs.filters_form.submit();
      }
    });
  },
  getDisplayName(value) {
    if (!value) return '';
    const parts = value.split(' - ');
    return parts.length > 1 ? parts.slice(1).join(' - ') : value;
  }
}))